import axios from 'axios'

const api = async (method, path, params) => axios[method](path, params)
const state = {
    category: null,
    categories: [],
}

const mutations = {
    set_category(state, payload) {
        state.category = payload
    },
    set_categories(state, payload) {
        state.categories = payload
    },
}

const actions = {
    async create(context, payload) {
        try {
            const results = await api('post', `order-category`, payload)
            context.commit('set_category', results.data.success.data)
        } catch (err) {
            throw err
        }
    },
    async fetchById(context, id) {
        try {
            const results = await api('get', `order-category/${id}`)
            context.commit('set_category', results.data.success.data)
        } catch (err) {
            throw err
        }
    },

    async fetchAll(context) {
        try {
            const results = await api('get', `order-category`)
            context.commit('set_categories', results.data.success.data)
        } catch (err) {
            throw err
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `order-category/${payload.id}`,
                payload
            )
            context.commit('set_category', results.data.success.data)
        } catch (err) {
            throw err
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `order-category/${id}`)
            context.commit('set_category', null)
            context.dispatch('fetchAll')
        } catch (err) {
            throw err
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
